import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AdmissionRecordingScreen from './AdmissionRecordingScreen';
import { ROUTES } from '../constants/routes';
import { ADMISSIONS_ENABLED } from '../constants/features';

export default function AdmissionRecordingRoute() {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!ADMISSIONS_ENABLED) {
      navigate(ROUTES.PATIENTS, { replace: true });
      return;
    }
    if (!id) {
      navigate(ROUTES.PATIENTS, { replace: true });
    }
  }, [id, navigate]);

  if (!id || !ADMISSIONS_ENABLED) return null;

  return <AdmissionRecordingScreen patientId={id} />;
}
